import styled from 'styled-components';
import { Text } from '@morressier/ts';

export const Container = styled.div`
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
